/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {useAuth} from '../../../../../modules/auth'
import {NotImported} from '../../../../components/NotInformat'
import {getConcessionaireImageSrc} from '../BoardUnitConsumers'

type Props = {
  unitConsumers: any[]
  setMyUnitConsumer: any
  setShowCreateAppModal: any
  setShowCreateAppModalDelete: any
  onOpenPlant: (plantId: string) => void
  onOpenConcessionaire: (unitConsumer: any) => void
}

export function TableBody({
  unitConsumers,
  setMyUnitConsumer,
  setShowCreateAppModal,
  setShowCreateAppModalDelete,
  onOpenPlant,
  onOpenConcessionaire,
}: // setShowCreateAppModalDetails
Props) {
  const handleButtonClickDelete = (event, unitConsumer) => {
    event.stopPropagation()
    setMyUnitConsumer(unitConsumer)
    setShowCreateAppModalDelete(true)
  }

  const user = useAuth()
  const handleButtonClickUpdate = (event: any, unitConsumer: any) => {
    event.stopPropagation()
    unitConsumer.idPlant = unitConsumer.plant.id ? unitConsumer.plant.id : null
    unitConsumer.idConcessionarie = unitConsumer.concessioraire
      ? unitConsumer.concessioraire.id
      : null
    setMyUnitConsumer(unitConsumer)
    setShowCreateAppModal(true)
  }

  return (
    <tbody>
      {unitConsumers && unitConsumers.length !== 0 ? (
        unitConsumers.map((unitConsumer: any) => {
          return (
            <tr
              onClick={() => {
                setMyUnitConsumer(unitConsumer)
              }}
            >
              <td>
                <div className='d-flex align-items-center'>
                  <div className='symbol symbol-45px me-5'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen001.svg'
                      className='svg-icon-muted svg-icon-3hx'
                    />
                  </div>
                  <div className='d-flex justify-content-start flex-column'>
                    <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
                      {unitConsumer.name ? (
                        unitConsumer.name
                      ) : (
                        <NotImported className='fs-6 text-gray-400 text-hover-primary' />
                      )}
                    </a>
                    {unitConsumer.name && (
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Descrição da unidade
                      </span>
                    )}
                  </div>
                </div>
              </td>

              <td>
                <span
                  className={`badge badge-light-${
                    unitConsumer.type_unit_consumer !== null
                      ? unitConsumer.type_unit_consumer === 'GERADORA'
                        ? 'primary'
                        : unitConsumer.type_unit_consumer === 'CONSUMIDORA'
                        ? 'info'
                        : 'secondary'
                      : 'secondary'
                  } fs-7 fw-semibold`}
                >
                  {unitConsumer.type_unit_consumer ? (
                    unitConsumer.type_unit_consumer
                  ) : (
                    <NotImported className='fs-6 text-gray-400 text-hover-primary' />
                  )}
                </span>
              </td>

              <td>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: '0.5rem',
                  }}
                >
                  <img
                    src={toAbsoluteUrl('/media/imgs/plant2.png')}
                    alt=''
                    style={{
                      width: '2.25rem',
                      height: '2.25rem',
                      borderRadius: '0.5rem',
                      objectFit: 'cover',
                      flexShrink: 0,
                    }}
                  />
                  <a
                    href='#'
                    className='text-dark fw-bold text-hover-primary d-block fs-6'
                    title={unitConsumer.plant?.id ? 'Ver detalhes da usina' : undefined}
                    onClick={(event) => {
                      event.preventDefault()
                      event.stopPropagation()
                      if (unitConsumer.plant?.id) onOpenPlant(unitConsumer.plant.id)
                    }}
                  >
                    {unitConsumer.plant ? (
                      unitConsumer.plant.plantName
                    ) : (
                      <NotImported className='fs-6 text-gray-400 text-hover-primary' />
                    )}
                  </a>

                  <span className={`badge badge-light-secondary fs-9 fw-semibold`}>
                    {unitConsumer.plant.plano ? (
                      unitConsumer.plant.plano
                    ) : (
                      <NotImported className='fs-6 text-gray-400 text-hover-primary' />
                    )}
                  </span>
                </div>
              </td>

              <td>
                <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                  {unitConsumer.contrato ? (
                    unitConsumer.contrato
                  ) : (
                    <NotImported className='fs-6 text-gray-400 text-hover-primary' />
                  )}
                </a>
                {unitConsumer.contrato && (
                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                    Número do contrato
                  </span>
                )}
              </td>

              <td>
                <div className='d-flex align-items-center' style={{gap: '0.75rem'}}>
                  {unitConsumer.concessioraire && (
                    <img
                      src={getConcessionaireImageSrc(unitConsumer.concessioraire.link_imagem)}
                      alt={unitConsumer.concessioraire.name}
                      style={{
                        width: '2.25rem',
                        height: '2.25rem',
                        objectFit: 'contain',
                        borderRadius: '0.5rem',
                        background: '#fff',
                        border: '1px solid var(--bs-gray-200)',
                        padding: '0.15rem',
                        flexShrink: 0,
                      }}
                    />
                  )}
                  <div className='d-flex flex-column'>
                    <a
                      href='#'
                      className='text-dark fw-bold text-hover-primary d-block fs-6'
                      title={unitConsumer.concessioraire ? 'Editar concessionária' : undefined}
                      onClick={(event) => {
                        event.preventDefault()
                        event.stopPropagation()
                        if (unitConsumer.concessioraire) onOpenConcessionaire(unitConsumer)
                      }}
                    >
                      {unitConsumer.concessioraire ? (
                        unitConsumer.concessioraire.name
                      ) : (
                        <NotImported className='fs-6 text-gray-400 text-hover-primary' />
                      )}
                    </a>
                    {unitConsumer.concessioraire && (
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Nome da Concessionária
                      </span>
                    )}
                  </div>
                </div>
              </td>

              {user.currentUser &&
                user.currentUser.companies &&
                user.currentUser.companies.length > 0 &&
                user.currentUser.companies[0].planos === 'PREMIUM' && (
                  <td>
                    <div
                      className={`mb-6 bg-${
                        unitConsumer.status !== null
                          ? unitConsumer.status === 'ATIVA'
                            ? 'success'
                            : unitConsumer.status === 'INATIVA'
                            ? 'danger'
                            : 'secondary'
                          : 'secondary'
                      } rounded-circle border border-4 border-white h-20px w-20px`}
                    ></div>
                  </td>
                )}

              <td>
                <div className='d-flex justify-content-end flex-shrink-0'>
                  {user &&
                    user.currentUser &&
                    user.currentUser.role &&
                    user.currentUser.role.slug &&
                    user.currentUser?.role.slug !== 'CLIENTE' && (
                      <button
                        onClick={(event: any) => {
                          handleButtonClickUpdate(event, unitConsumer)
                        }}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                      >
                        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                      </button>
                    )}

                  {unitConsumer.type_unit_consumer &&
                    unitConsumer.type_unit_consumer !== 'GERADORA' && (
                      <button
                        onClick={(event: any) => {
                          handleButtonClickDelete(event, unitConsumer)
                        }}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                      >
                        <KTSVG
                          path='/media/icons/duotune/general/gen027.svg'
                          className='svg-icon-3'
                        />
                      </button>
                    )}
                </div>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={6} style={{textAlign: 'center'}}>
            <div className='d-flex justify-content-center' style={{padding: '2rem'}}>
              <span className='text-muted fw-semibold text-muted d-block fs-4'>
                Unidades Consumidoras não encontradass!
              </span>
            </div>
          </td>
        </tr>
      )}
    </tbody>
  )
}
